import { Box, Heading } from '@grupoboticario/flora-react'
import { useTranslation } from 'react-i18next'

type TProps = {
  number: string
}

const Header = ({ number }: TProps) => {
  const { t } = useTranslation()

  return (
    <Box
      css={{
        '@tablet': {
          width: 600
        },
        margin: '0 auto',
        width: '100%',
        gap: '$2'
      }}
    >
      <Heading
        level={3}
        as="h1"
        css={{ fontSize: '35px', fontWeight: '400', lineHeight: '40px' }}
        className={process.env.REACT_APP_ENV || 'env-fail'}
      >
        {t('formTitle')}
      </Heading>
      <Heading level={5} as="h2" css={{ display: 'block', marginTop: '8px', fontSize: '22px', fontWeight: '400' }}>
        {t('code', { code: number })}
      </Heading>
    </Box>
  )
}

export default Header
